// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9277be8","455":"625ac74c","977":"af3110c8"}[chunkId] + ".chunk.js";
};